module.exports = __webpack_public_path__ + "img/reservation_m.c3974e83.png";